module.exports = __webpack_public_path__ + "img/ns-np.f95ffb03.png";